import { Navigate, useSearchParams } from 'react-router-dom';
import {
  ENROLLMENT_ERROR_PAGES,
  FIVE_STEP_ENROLLMENT_PATH,
} from 'services/enrollment/config';
import PreserveQueryRedirect from './PreserveQueryRedirect';

/* The codes an employee-benefits link must carry for the flow to have anything to enrol into. */
const REQUIRED_PARAMS = ['offer_code', 'plan_code', 'group_code'];

/**
 * identityWeb mounts the whole enrollment module a second time at `eb/enrollment` behind
 * `EmployeeBenefitsGuard` (app-routing.module.ts:230-236), which admits the link only when it
 * carries the offer, plan and group codes and otherwise rejects to the technical-difficulties
 * page. privacyShield has one enrollment entry point, so the alias becomes a guarded redirect
 * onto it rather than a second mount.
 *
 * The guard checks all three codes. identityWeb's tests `groupCode` twice and never reads
 * `planCode` (employee-benefits-guard.service.ts:15), which lets a link through that the flow
 * cannot serve — its query-param branch shows the intent, and that is what is ported.
 */
function EbEnrollmentRoute() {
  const [searchParams] = useSearchParams();

  const hasEveryCode = REQUIRED_PARAMS.every((param) =>
    searchParams.get(param)?.trim(),
  );

  if (!hasEveryCode) {
    return (
      <Navigate to={ENROLLMENT_ERROR_PAGES.technicalDifficulties} replace />
    );
  }

  /* The codes live only in the query string, so it has to survive the hop. */
  return <PreserveQueryRedirect to={FIVE_STEP_ENROLLMENT_PATH} />;
}

export default EbEnrollmentRoute;
